import {Directive, ElementRef, EventEmitter, HostListener, OnDestroy, Output, Renderer2} from '@angular/core';

@Directive({
    selector: '[clickOutside]'
})
export class ClickOutsideDirective implements OnDestroy {
    @Output()
    public clickOutside = new EventEmitter<MouseEvent>();

    private removeClickListenerFn: () => void;

    constructor(private _elementRef: ElementRef, private renderer: Renderer2) {
        this.registerClickListener();
    }

    private registerClickListener(): void {
        this.removeClickListenerFn = this.renderer.listen('document', 'click', (event: MouseEvent) => {
            const targetElement = event.target as HTMLElement;
            if (!targetElement) {
                return;
            }

            const clickedInside = this._elementRef.nativeElement.contains(targetElement);
            if (!clickedInside) {
                this.clickOutside.emit(event);
            }
        });
    }

    ngOnDestroy(): void {
        if (this.removeClickListenerFn) {
            this.removeClickListenerFn(); // Remove the listener
        }
    }
}
